/* global attachEvent */

// *******************************************************************************
// 1.0 - Open Gallery-modal
// *******************************************************************************

attachEvent('.gallery-block', 'click', (ev) => {
  const parentEle = ev.target.closest('.sc-gallery-list');
  const galleryModal = parentEle.querySelector('.gallery-modal');
  if (galleryModal) {
    galleryModal.classList.add('is-open-gallery-modal');
  }
});
